import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MantineProvider } from '@mantine/core';
import { BrowserRouter } from 'react-router-dom';
import { UserAuthContextProvider } from './Context/Userauthcontext';
import { AdminAuthContextProvider } from './Context/Adminauthcontext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AdminAuthContextProvider>
        <UserAuthContextProvider>
          <MantineProvider>
            <App />
          </MantineProvider>
        </UserAuthContextProvider>
      </AdminAuthContextProvider> 
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
